module.exports = __webpack_public_path__ + "img/why-ico5.a359f62b.png";